import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { Link } from '@inertiajs/react';
import { color } from '../templates/Ui';
const StyledAuthLink = styled(Link) `
    position: relative;
    display: inline-block;
    color: ${props => props.theme.primary.dark};
    margin-top: 20px;
    text-decoration: none;
    font-size: 15px;
    padding-bottom: 4px;

    &:before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        height: 1px;
        background-color: ${color.gray.base};
        transition: all 200ms ease-in-out;
        border-radius: 1px;

        @media only screen and (min-width: 992px) {
            width: 0;
        }
    }

    &:hover {
        @media only screen and (min-width: 992px) {
            &:before {
                width: 100%;
            }
        }
    }

    &:focus {
        outline: none;
    }
`;
const AuthLink = ({ href, ...props }) => _jsx(StyledAuthLink, { href: href, ...props });
export default AuthLink;
